import { useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { useDispatch } from "react-redux";
import { setAuthInfo } from "../userSlice";
import { clearDietaryRestrictions } from "../../products/productsSlice";
import { resetReferrals } from "../../referrals/referralsSlice";
import { setGoogleLoginError } from "../../mobile/mobileSlice";

const AuthFinish = () => {
    const navigate = useNavigate();
    const dispatch = useDispatch();

    useEffect(() => {
        const url = new URL(window.location.href.replace("median://", "https://"));
        const params = url.searchParams;

        const status = params.get("status");
        const token = params.get("token");
        const email = params.get("email");
        const error = params.get("error");

        if (status === "success" && token && email) {
            const authData = {
                token,
                email,
                nicename: email.split("@")[0],
                display_name: email,
                isRememberMe: false,
                dateStored: new Date(),
            };

            localStorage.setItem("token", token);
            localStorage.setItem("setAuthInfo", JSON.stringify(authData));

            dispatch(setAuthInfo(authData));
            dispatch(clearDietaryRestrictions());
            dispatch(resetReferrals());

            navigate("/");
        } else {
            localStorage.removeItem("token");
            localStorage.removeItem("setAuthInfo");
            if (error) dispatch(setGoogleLoginError(`Google login failed: ${error}`));
            navigate("/my-account?error=" + (error || "auth_failed"));
        }
    }, [dispatch, navigate]);

    return <p>Finishing login, please wait...</p>;
};

export default AuthFinish;